import script from "./Quote.vue?vue&type=script&setup=true&lang=ts"
export * from "./Quote.vue?vue&type=script&setup=true&lang=ts"

import "./Quote.vue?vue&type=style&index=0&id=034ff610&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-034ff610"]])

export default __exports__